import { Table } from "@mantine/core";

export function SystemEmailRegistryHeader() {
  return (
    <Table.Thead>
      <Table.Tr>
        <Table.Th>Subject and email trigger</Table.Th>
        <Table.Th miw={190}>Category</Table.Th>
        <Table.Th w={240}>Mode</Table.Th>
        <Table.Th w={180}>Preview</Table.Th>
      </Table.Tr>
    </Table.Thead>
  );
}
